import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiService} from '@app/shared/services/api.service';


@Injectable({
  providedIn: 'root'
})
export class OrderService {
  constructor(private api: ApiService) {
  }

  medicine_search(term: string) {
    if (term == '') {
      return of([]);
    }
    if (term.length > 2) {
      return this.api
        .post("PurchaseOrder/listMedicine", {
          search_text: term,
          limit: 10,
          medicine_id: '0',
          start: 0
        });
    } else {
      return of([]);
    }

  }

  price_medicine_search(term: string) {
    if (term == '') {
      return of([]);
    }
    return this.api.post('Medicine/listMedicine', JSON.stringify({search_text: term, limit: 10, medicine_id: '0', start: 0}))
  }

  medicine_purchase_search(term: string, order_id: any, vendor_id: any) {
    if (term == '') {
      return of([]);
    }
    if (term.length > 2) {
      return this.api
        .post('Purchase/searchMedicine',{
          search_text: term,
          limit: 10,
          vendor_id: vendor_id,
          order_id: order_id,
          start: 0
        })
    } else {
      return of([]);
    }

  }

  medicine_combo_search(term: string) {
    if (term == '') {
      return of([]);
    }
    if (term.length > 2) {
      return this.api
        .post('ComboProduct/listMedicine', JSON.stringify({search_text: term, limit: 10, start: 0}))
    } else {
      return of([]);
    }

  }

  listVendor(opData: any): Observable<any> {
    return this.api.post('PurchaseOrder/listVendor', opData)
  }

  savePurchaseOrder(opData: any): Observable<any> {
    return this.api.post('PurchaseOrder/savePurchaseOrder', opData)
  }

  saveSupplierPrice(opData: any): Observable<any> {
    return this.api.post('SupplierPrice/saveSupplierPrice', opData)
  }

  savePurchaseReceived(opData: any): Observable<any> {
    return this.api.post('Purchase/savePurchaseReceived', opData)
  }

  getOrder(opData: any): Observable<any> {
    return this.api.post('PurchaseOrder/getOrder', opData)
  }

  getComboProduct(opData: any): Observable<any> {
    return this.api.post('ComboProduct/getComboProduct', opData)
  }

  listPrice(opData: any): Observable<any> {
    return this.api.post('ComboProduct/listPrice', opData)
  }

  listDamage(opData: any): Observable<any> {
    return this.api.post('Damage/listDamage', opData)
  }

  deletePurchaseOrder(opData: any): Observable<any> {
    return this.api.post('PurchaseOrder/deletePurchaseOrder', opData)
  }

  deleteCombo(opData: any): Observable<any> {
    return this.api.post('ComboProduct/deleteCombo', opData)
  }

  deletePrice(opData: any): Observable<any> {
    return this.api.post('ComboProduct/deletePrice', opData)
  }

  listPurchaseOrder(opData: any): Observable<any> {
    return this.api.post('PurchaseOrder/listPurchaseOrder', opData)
  }

  listOrderNo(opData: any): Observable<any> {
    return this.api.post('Purchase/listOrderNo', opData)
  }

  deleteDamage(opData: any): Observable<any> {
    return this.api.post('Damage/deleteDamage', opData)
  }

  UpdatePurchase(opData: any): Observable<any> {
    return this.api.post('Purchase/UpdatePurchase', opData)
  }

  closeOrder(opData: any): Observable<any> {
    return this.api.post('PurchaseOrder/closeOrder', opData)
  }

  savePaymentDetails(opData: any): Observable<any> {
    return this.api.post('PurchaseOrder/savePaymentDetails', opData)
  }

}
